import React from "react";
import {
  Row,
  Col,
  Space,
  Typography,
  Button,
  Checkbox,
  Skeleton,
  Tabs,
  
} from "antd";
import { Colors } from "../../../../theme";
import EditableTable from "./EditableTable";
import Loader from "react-loader-spinner";

const { Title } = Typography;
const { TabPane } = Tabs;
export default function ViewCollection({
  collectionDetails,
  draftLoadingStatus,
  setCollectionStatus,
  setDraftLoadingStatus,
  history,
  handleContinue,
  ShowColumnOptions,
  onChangeShowColumnOptions,
  callback,
  editCollectionProducts,
  showPrice,
  showMoq,
  showLeadTime,
  showSamplingTime,
  collectionId,
  type,
  setIsChildrenLoaded
}) {
  return (
    <div>
      {collectionDetails   ? (
        <span>
          <Row justify="space-between" style={{ marginTop: 12 }}>
            <Col>
              <Col>
                <Space direction="vertical" size="50">
                  <Title level={3} style={{ fontFamily: "Gilroy" }}>
                    {collectionDetails?.collection_name}
                  </Title>
                  <Typography.Text style={{ color: Colors.gray }}>
                    Edit the details of products and select what the buyer can
                    see
                  </Typography.Text>
                </Space>
              </Col>
            </Col>
            <Col>
              <Button
                size="large"
                style={{ width: "12rem", marginRight: "1rem", backgroundColor:"#F0F8F6" }}
                loading={draftLoadingStatus}
                onClick={() => {
                  setCollectionStatus("draft");
                  setDraftLoadingStatus(true);
                  // handleContinue();
                  // saveAsDraft();
                }}
              >
                {draftLoadingStatus ? "Saving..." : " Save as draft"}
              </Button>
              <Button
                size="large"
                type="primary"
                style={{
                  width: "12rem",
                  marginRight: "1rem",
                  background: Colors.primaryColorTint,
                  color: Colors.primaryColor,
                }}
                onClick={() =>
                  history.push({
                    pathname: `/select-products/${collectionId}`,

                    state: { type: type ? "edit" : null },
                  })
                }
              >
                + Add more products
              </Button>
              <Button
                size="large"
                style={{ width: "12rem" }}
                type="primary"
                onClick={() => {
                  handleContinue();
                }}
              >
                Continue
              </Button>
            </Col>
          </Row>

          <Row style={{ marginTop: "0.75rem", marginBottom: "0.25rem" }}>
            <Checkbox.Group
              options={ShowColumnOptions}
              defaultValue={ShowColumnOptions.flatMap((item) => item.value)}
              onChange={onChangeShowColumnOptions}
            />
          </Row>

          <Row>
            <Col span={24}>
              <Tabs onChange={callback}>
                {editCollectionProducts?.length > 0 || collectionDetails? (
                   editCollectionProducts && editCollectionProducts.map((item, index) => (
                    <TabPane
                      tab={`${item?.name} (${
                        item?.values.length ? item?.values.length : 0
                      })`}
                      key={index}
                    >
                      <EditableTable
                        tabName={item?.name}
                        dataSource={
                          item?.values?.length > 0 ? item?.values : []
                        }
                        setIsChildrenLoaded={setIsChildrenLoaded}
                        showPrice={showPrice}
                        showMoq={showMoq}
                        showLeadTime={showLeadTime}
                        showSamplingTime={showSamplingTime}
                        editCollectionProducts={editCollectionProducts}
                      />
                    </TabPane>
                  ))
                ) : (
                  <Row style={{width:'100%'}} >
                    <Col span={10} offset={10} >
                      <Loader type="ThreeDots" color={Colors.primaryColor}/>
                    </Col>
                  </Row>
                )}
              </Tabs>
            </Col>
          </Row>
        </span>
      ) : (
        <Skeleton active />
      )}
    </div>
  );
}
